export default __webpack_public_path__ + "static/media/output-onlinejpgtools.0c48524d.png";